import React, { useContext, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import TokenContext from '../../context/TokenContext';
import { UserAuth } from '../../context/AuthContext';

import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import CircularProgress from '@mui/material/CircularProgress';
import { avanceMensualXobjetivo, editarAvancesMensualesObjetivos, limpiarAvancesXobjetivos, objetivosPorPGD } from '../../Redux/evaluaciones';
import { COLUMNSAVANCESOBJ } from '../../columnas/columnasObjetivosFeedback';
import TablaAvancesXobjetivos from '../tablas/TablaAvancesXobjetivos';
import TablaAvancesEditables from '../tablas/TablaAvancesEditables';
import ModalEditarAvances from './ModalEditarAvances';
import { toast } from "react-toastify"

const ModalAvances = ({ open, handleClose, id, status, isLider, idPGD, instancia }) => {
    const dispatch = useDispatch()
    const token = useContext(TokenContext)

    const [avances, setAvances] = React.useState([])
    const avanceSelector = useSelector(store => store.evaluaciones.avanceObj)
    const loadingAvances = useSelector(store => store.evaluaciones.loadingAvanceObj)

    const [openModal, setOpenModal] = useState(false)
    const [target, setTarget] = useState({})

    const [mesDisponible, setMesDisponible] = useState(false);

    useEffect(() => {
        if (token && id) {
            dispatch(avanceMensualXobjetivo(token, id))
        }
    }, [id, token])

    useEffect(() => {
        if (avanceSelector.length > 0) {
            const newArray = avanceSelector.map((element) => ({
                id: element.new_avancemensualid,
                new_indicemensual: element.new_indicemensual,
                new_mes: element["new_mes@OData.Community.Display.V1.FormattedValue"],
                new_deavance: element.new_deavance,
                isLider: isLider,
                // new_status: element["ab.new_status"],
                new_status: status,
                new_objetivodeevaluacion : id,
                estadoTerceraEtapa : element["af.new_estadodelencuentrodefeedback"],
                new_scoreglobaldeobjetivos : element["af.new_scoreglobaldeobjetivos"],
            }))
            setAvances(newArray)
        }
    }, [avanceSelector, isLider])

    useEffect(() => {
        if (avances.length > 0) {
            const mesesDisponibles = avances.map(avance => avance.new_indicemensual);
            const currentDate = new Date();
            const currentMonth = currentDate.getMonth() + 1;
            setMesDisponible(mesesDisponibles.includes(currentMonth));
        }
    }, [avances])


    const cerrarYlimpiar = () => {
        handleClose(false)
        setAvances([])
        dispatch(limpiarAvancesXobjetivos());
    }

    const handleSave = () => {
        const currentDate = new Date();
        const currentMonth = currentDate.getMonth() + 1;
    
        let isValid = true;
        let errorMessage = '';

        const avanceMesActual = avances.find(avance => {
            return avance.new_indicemensual === currentMonth
        });

        const index = avances.findIndex(avance => {
            return avanceMesActual.id === avance.id
        });
    
        if (avanceMesActual) {
            const { new_deavance, new_mes } = avanceMesActual;
            if (isNaN(new_deavance)) {
                errorMessage = `El valor del % de Avance del mes de ${ new_mes } no es un número.`;
                isValid = false;
            }
            else if (new_deavance < 0 || new_deavance > 100) {
                errorMessage = `El valor del % de Avance del mes de ${ new_mes } debe estar entre 0 y 100.`;
                isValid = false;
            }
            else if (new_deavance % 10 != 0) {
                errorMessage = `El valor del % de Avance del mes de ${ new_mes } debe ser múltiplo de 10.`;
                isValid = false;
            }
            else if ( index > 0 ) {
                for (let i = 0; i < index; i++) {
                    if(avances[i].new_deavance > avanceMesActual.new_deavance) {
                        errorMessage = `El avance mensual debe ser igual o incremental a los anteriores.`;
                        isValid = false;
                        break;
                    }
                }
            }

        } else {
            errorMessage = `No hay avances registrados para el mes actual.`;
            isValid = false;
        }
    
        if (isValid) {
            handleClose(false);
            dispatch(editarAvancesMensualesObjetivos(token, avanceMesActual))
            .then(() => {
                dispatch(objetivosPorPGD(token, idPGD));
            })
            .catch((error) => {
                console.error("Error:", error);
            });
        } else {
            toast.error(errorMessage, {
                theme: "dark",
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        }
    }

    const handleEditableFieldValue = (id, newValue) => {
        const updatedAvances = avances.map(avance => {
            if (avance.id === id) {
                return {
                ...avance,
                new_deavance: newValue
                };
            }
            return avance;
        });
        setAvances(updatedAvances);
    };
    
    const handleOpenEditar = (id) => {
        setTarget(avances?.find((item) => item.id === id))
        setOpenModal(true)
    }

    const handleCloseEditar = () => {
        setOpenModal(false)
        setTarget({})
        dispatch(avanceMensualXobjetivo(token, id))
      };

    return (
        <>
            <Dialog
                open={open}
                onClose={() => cerrarYlimpiar()}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                maxWidth='sm'
            >
                <DialogTitle>Avances Mensuales del Objetivo</DialogTitle>
                <DialogContent>
                    {
                        loadingAvances ? (
                            <Box
                                sx={{
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    width: '100%',
                                    height: '100%',
                                    py: 2
                                }}>
                                <CircularProgress color="secondary" />
                            </Box>
                        ) :
                            avances.length > 0 && avances[0].new_objetivodeevaluacion === id ? (
                                <>
                                    <TablaAvancesEditables
                                        columnas={COLUMNSAVANCESOBJ}
                                        lineas={avances}
                                        acciones={isLider}
                                        handleOpen={handleOpenEditar}
                                        handleEditableFieldValue={handleEditableFieldValue}
                                    />
                                </>
                            ) :
                                <Alert severity="info">
                                    <AlertTitle>Info</AlertTitle>
                                    No existen registros de — <strong>Avances Mensuales</strong>.
                                </Alert>
                    }
                </DialogContent>
                <DialogActions>
                    <Button 
                        onClick={() => handleSave()} 
                        color="secondary" 
                        variant="contained"
                        disabled={!mesDisponible || avances.length === 0 || !isLider || avances[0].new_status === 100000001 || avances[0].new_status === 100000003 || avances[0].estadoTerceraEtapa === 100000001 || avances[0].new_scoreglobaldeobjetivos }
                    > 
                        {
                            instancia === "Balance y Cierre de Año" ? <>Guardar</> : <>Previsualizar</> 
                        }
                    </Button>
                    <Button onClick={() => cerrarYlimpiar()} color="secondary" variant="contained">
                        Cerrar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ModalAvances